import Api_Masterdata from '../api-masterdata'

const api_masterdata = new Api_Masterdata().init()

const synchroPlant = () => {
  return api_masterdata.post(
    `/syncronize/plant?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const synchroSalesArea = () => {
  return api_masterdata.post(
    `/syncronize/sales_area?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}
const synchroSalesOffice = () => {
  return api_masterdata.post(
    `/syncronize/sales_office?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}
const synchroMaterial = () => {
  return api_masterdata.post(
    `/syncronize/material-product?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const synchroMaterialParam = (mat = '', date1 = '', date2 = '') => {
  return api_masterdata.post(
    `/syncronize/material-product?material_number=${mat}&low_date=${date1}&high_date=${date2}&credentials=${localStorage.getItem(
      'credential'
    )}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const synchroCustomer = () => {
  return api_masterdata.post(
    `/syncronize/customer?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const synchroStorLoc = () => {
  return api_masterdata.post(
    `/syncronize/sloc?credentials=${localStorage.getItem('credential')}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const synchroBankKey = (low = '', high = '') => {
  return api_masterdata.post(
    `/bank-key/sync?low_date=${low}&high_date=${high}&credentials=${localStorage.getItem(
      'credential'
    )}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPlant = () => {
  return api_masterdata.get(`/plant?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAreaAll = () => {
  return api_masterdata.get(
    `/sales-area-assignment?credentials=${localStorage.getItem('credential')}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

export {
  synchroPlant,
  synchroSalesArea,
  synchroSalesOffice,
  synchroMaterial,
  synchroCustomer,
  getPlant,
  getAreaAll,
  synchroMaterialParam,
  synchroStorLoc,
  synchroBankKey,
}
